import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@mui/material';
import { SmallFormDateField } from '../../../components/small-fields/SmallFormDateField';
import { formatDate } from '../../../services/functions';

export function GenerateSeatAvailabilityNoAgeRangeModal({
  open,
  handleClose,
  handleGenerate,
  loading
}) {
  const [date, setDate] = React.useState(new Date());

  const handleSubmit = () => {
    if (!date) {
      return;
    };
    handleGenerate(date);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Wybierz datę raportu</DialogTitle>
      <DialogContent>
        <SmallFormDateField
          type="date"
          fullWidth
          value={date}
          onChange={value => setDate(formatDate(value))}
          sx={{ mt: 2, minWidth: 400 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Anuluj</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!date || loading}
        >
          Generuj
        </Button>
      </DialogActions>
    </Dialog>
  );
}
